import React, { useState } from 'react';
import { motion } from 'framer-motion';
import ChartsContent from '../Charts/ChartsContent';

import { SidebarProps } from '../../../../types';
import { Translation } from '../../../../types/translation';

import './Sidebar.css';

import rawEn from '../../../../locales/en.json';
import rawJa from '../../../../locales/ja.json';
import rawPt from '../../../../locales/pt.json';

const en: Translation = rawEn;
const ja: Translation = rawJa;
const pt: Translation = rawPt;

const translations: Record<string, Translation> = { en, ja, pt };

const lang = process.env.REACT_APP_LANGUAGE || 'en';
const t = translations[lang] || en;

const Sidebar: React.FC<SidebarProps> = ({
  onToggle,
  isActive,
  htmlDetailBuoy,
  noData,
  mobile,
  buoysLoadMap,
  dataBuoy,
  measurementUnits,
  lastTimeStamp,
  lastBuoyTimeStamp,
  selectedNameBuoy,
  logoBuoy,
  theme,
  lat_str,
  longi_str,
  utcOffset,
}) => {
  const [activeTab, setActiveTab] = useState<'details' | 'charts'>('details');

  const handleTabClick = (tab: 'details' | 'charts') => {
    setActiveTab(tab);
  };

  const motionVariants = {
    hidden: { opacity: 0, scale: 0.8, y: 50 },
    visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.6 } },
    exit: { opacity: 0, scale: 0.8, y: 50, transition: { duration: 0.5 } },
  };

  const iconChevron =
    theme === 'light'
      ? 'assets/img/icon-chevron.svg'
      : 'assets/img/icon-chevron-dark.svg';

  return (
    <div
      className={`sidebar ${buoysLoadMap ? '' : 'sidebar-hidden'} ${
        isActive ? 'sidebar-close' : ''
      }`}
    >
      {mobile ? (
        <div className="sidebar-buttons">
          <button
            className={`${isActive ? 'button-dades' : ''}`}
            onClick={() => onToggle('DATA')}
          >
            {t.sidebar.mapButtons.data}
          </button>
          <button
            className={`${isActive ? '' : 'button-map'}`}
            onClick={() => onToggle('MAP')}
          >
            {t.sidebar.mapButtons.map}
          </button>
        </div>
      ) : (
        <div
          className="sidebar-button sidebar-open-close-button"
          onClick={() => onToggle('')}
          title="Toggle Sidebar"
        >
          <img src={iconChevron} alt="toggle sidebar" />
        </div>
      )}

      <div className="sidebar-content">
        {htmlDetailBuoy && (
          <div className="sidebar-tabs">
            <button
              className={`tab-button ${
                activeTab === 'details' ? 'active' : ''
              }`}
              onClick={() => handleTabClick('details')}
            >
              {t.sidebar.tabs.details}
            </button>
            <button
              className={`tab-button ${activeTab === 'charts' ? 'active' : ''}`}
              onClick={() => handleTabClick('charts')}
            >
              {t.sidebar.tabs.charts}
            </button>
          </div>
        )}
        {activeTab === 'details' ? (
          htmlDetailBuoy ? (
            /*
            <>
               <div className="details-tab-content">
                <div dangerouslySetInnerHTML={{ __html: htmlDetailBuoy }} />
              </div>
            </>
            */
            <div dangerouslySetInnerHTML={{ __html: htmlDetailBuoy }} />
          ) : noData ? (
            <div className="sidebar-message">
              <p>{t.sidebar.noDataMessage}</p>
              <img
                src="assets/img/img_selected-map.svg"
                alt="Tapping on a buoy on the map"
              />
            </div>
          ) : (
            <div className="skeleton-loader">
              <h1>
                <span className="skeleton-item">Loading...</span>
              </h1>
              <div className="skeleton-item ubication">
                <img src="assets/img/icon-pointer.svg" alt="Pointer map" />
                <span>Barcelona, Catalonia</span>
              </div>
              <div className="date">
                <span className="skeleton-item">
                  <img src="assets/img/icon-date.svg" alt="Date" />
                </span>
                <span className="skeleton-item">25/04/1987 ~ 03:00 AM</span>
              </div>
            </div>
          )
        ) : (
          <motion.div
            key="charts-content"
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={motionVariants}
          >
            <ChartsContent
              dataBuoy={dataBuoy}
              measurementUnits={measurementUnits}
              lastTimeStamp={lastTimeStamp}
              lastBuoyTimeStamp={lastBuoyTimeStamp}
              selectedNameBuoy={selectedNameBuoy}
              logoBuoy={logoBuoy}
              theme={theme}
              lat_str={lat_str}
              longi_str={longi_str}
              utcOffset={utcOffset}
            />
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default Sidebar;
